import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getFirestoreDb, isFirebaseConfigured } from './config';

export const LEAD_STATUS = {
  NEW: 'new',
  CONTACTED: 'contacted',
  CLOSED: 'closed',
};

/**
 * Create a lead (public / website). Cloud Function `onLeadCreate` sends email/WhatsApp.
 * @returns {{ ok: true } | { ok: false, skipped: true }}
 */
export async function submitLead({
  name,
  email,
  phone,
  message,
  source = 'website',
  extraFields = {},
}) {
  if (!isFirebaseConfigured()) {
    return { ok: false, skipped: true };
  }
  const db = getFirestoreDb();
  if (!db) {
    return { ok: false, skipped: true };
  }

  const now = serverTimestamp();
  const resolvedSource =
    extraFields.source != null ? extraFields.source : source || 'website';
  const { source: _omit, status: _st, createdAt: _ca, updatedAt: _ua, ...safeExtra } =
    extraFields;

  await addDoc(collection(db, 'leads'), {
    name: name || '',
    email: email || '',
    phone: phone || '',
    message: message || '',
    source: resolvedSource,
    status: LEAD_STATUS.NEW,
    createdAt: now,
    updatedAt: now,
    ...safeExtra,
  });

  return { ok: true };
}
